module.exports = __webpack_public_path__ + "static/img/info-3.43617f2e.png";